app.factory("SysParam", ["$http",
    function ($http) {
        var SysParam = {};

        SysParam.getSysParam = function (key) {
            return $http.get("/sysparam/" + key).then(function (resp) {
                return resp.data;
            })
        };

        SysParam.sysParamList = function () {
            return $http.get("/sysparam/list").then(function (resp) {
                return resp.data;
            });
        };

        SysParam.createSysParam = function (params) {
            return $http.post("/sysparam/create", {
                _id: params.key,
                name: params.name,
                description: params.description,
                value: params.value,
                type: params.type
            }).then(function (resp) {
                return resp.data;
            });
        };

        SysParam.updateSysParam = function (params) {
            return $http.post("/sysparam/update", {
                _id: params.key || params._id,
                name: params.name,
                description: params.description,
                value: params.value,
                type: params.type
            }).then(function (resp) {
                return resp.data;
            });
        };

        SysParam.fetchRoleList = function (id) {
            return $http.post("/sysparam/remove", {
                _id: id
            }).then(function () {
                return true;
            });
        };

        return SysParam;
    }
]);